document.querySelectorAll('[data-announcement]').forEach((banner) => {
  banner.querySelector('[data-announcement-dismiss]').addEventListener('click', () => {
    banner.hidden = true
    document.querySelector('.nav a')?.focus()
    try {
      localStorage.setItem(`announcement:${banner.dataset.announcement}`, 'dismissed')
    } catch (_) {
      // Dismissal still works when storage is unavailable.
    }
    document.dispatchEvent(new CustomEvent('announcement:dismissed'))
  })
})
